import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "upload_body"
};
const _hoisted_2 = {
  class: "upload_body_nr"
};
const _hoisted_3 = {
  class: "upload_list"
};
const _hoisted_4 = {
  key: 0,
  style: {
    "width": "347px"
  },
  src: "https://www.mimodental.com/assets/imgData/img/member_preferential/empty.png"
};
const _hoisted_5 = {
  class: "time"
};
const _hoisted_6 = {
  key: 0,
  class: "one_y",
  src: "https://www.mimodental.com/assets/imgData/img/member_record/one_y.png",
  alt: ""
};
const _hoisted_7 = {
  key: 1,
  src: "https://www.mimodental.com/assets/imgData/img/member_record/y.png",
  alt: ""
};
const _hoisted_8 = {
  key: 0,
  class: "remark"
};
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = ["src", "onClick"];
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  key: 2
};
const _hoisted_14 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[1] || (_cache[1] = _createElementVNode("h1", null, "诊疗记录", -1)), _createElementVNode("div", _hoisted_3, [$setup.upList.length == 0 ? (_openBlock(), _createElementBlock("img", _hoisted_4)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.upList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index
    }, [_createElementVNode("div", _hoisted_5, [index == 0 ? (_openBlock(), _createElementBlock("img", _hoisted_6)) : (_openBlock(), _createElementBlock("img", _hoisted_7)), _createElementVNode("span", null, _toDisplayString(item.clinicDate), 1)]), item.title ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item.title), 1)) : _createCommentVNode("", true), item.text ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      innerHTML: item.text,
      class: "upload_text"
    }, null, 8, _hoisted_9)) : _createCommentVNode("", true), item.uploadList ? (_openBlock(), _createElementBlock("div", {
      key: 2,
      class: "fill",
      style: _normalizeStyle('margin-bottom:' + (index + 1 != $setup.upList.length ? '100px;' : '0px'))
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.uploadList, (ite, inde) => {
      return _openBlock(), _createElementBlock("div", {
        class: "fill_dome",
        key: inde
      }, [ite.type == 'image' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("img", {
        src: ite.url,
        onClick: $event => $setup.look(ite.url),
        alt: ""
      }, null, 8, _hoisted_11)])) : ite.type == 'video' ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        onClick: $event => $setup.look(ite.url)
      }, _cache[0] || (_cache[0] = [_createElementVNode("img", {
        src: "https://www.mimodental.com/assets/imgData/imgs/vido_icon.png",
        alt: ""
      }, null, -1), _createElementVNode("img", {
        src: "https://www.mimodental.com/assets/imgData/imgs/bf.png",
        alt: "",
        class: "bf_icon"
      }, null, -1)]), 8, _hoisted_12)) : (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("img", {
        src: "https://www.mimodental.com/assets/imgData/imgs/file.png",
        onClick: $event => $setup.look(ite.url),
        alt: ""
      }, null, 8, _hoisted_14)]))]);
    }), 128))], 4)) : _createCommentVNode("", true)]);
  }), 128))])])]);
}